import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { BillingStatus } from 'src/app/enums/enums';
import { BillingService } from 'src/app/services/core/billing/billing.service';
import { sweetAlert } from 'src/app/utils/swal';

@Component({
  selector: 'app-billing-trip-reject-reason-modal',
  templateUrl: './billing-trip-reject-reason-modal.component.html',
  styleUrls: ['./billing-trip-reject-reason-modal.component.css']
})
export class BillingTripRejectReasonModalComponent implements OnInit {
  @Input() selectedIds: any;
  @Output() closeModal = new EventEmitter<any>();
  reasonForm!: FormGroup;
  submitted = false;

  constructor(
    private billingService: BillingService,
    private fb: FormBuilder
  ) {}

  ngOnInit() {
    this.reasonForm = this.fb.group({
      rejectReason: ['', Validators.required]
    });
  }

  onSave() {
    this.submitted = true;
    if (this.reasonForm.invalid) return;

    sweetAlert(
      "Alert",
      "Are you sure you want to reject the selected trip(s)?",
      "warning",
      "Yes",
      "No"
    ).then((result: any) => {
      if (result.value) {
        this.rejectRequest();
      }
    });
  }

  rejectRequest() {
    const payload  = {
      status: BillingStatus.REJECTED,
      selectedIds: this.selectedIds,
      billingRejectReason: this.reasonForm.value.rejectReason
    };
    this.billingService
      .updateBillingStatus(payload)
      .subscribe(data => {
        if (data) {
          const data = {
            reason: this.reasonForm.value.rejectReason,
            selectedIds: this.selectedIds
          }
          this.closeModal.emit(data);
        }
      });
  }

  onCloseModal() {
    this.closeModal.emit();
  }

  get form() {
    return this.reasonForm.controls;
  }
}
